import axios from 'axios';

export const httpClient = axios.create({
    responseType: 'json',
    responseEncoding: 'utf8',
    adapter: 'fetch',
});

export function setLanguageHeader(locale: string): void {
    httpClient.defaults.headers['Portal-Language'] = locale;
}
